/** Serialized values are shared with the existing editor. */
export enum BlockLoopSourceEnum {
  Question = 1,
  Options = 2,
  Media = 3
}
